import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for withdrawal requests.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieves the localization service and date format configuration
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);

        // Extends the Webix data filter to calculate and display column summaries
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the summary column with calculated values.
                 * @param {Object} master - The datatable instance.
                 * @param {HTMLElement} node - The HTML node of the column.
                 * @param {Object} value - The column configuration.
                 */
                refresh: function(master, node, value) {
                    var result = 0;
                    var resultFormat = 0;

                    // Iterates through the data to calculate the sum for the specified column
                    master.data.each(function(obj) {
                        if (obj.$level == 1) result += obj[value.columnId];
                    });

                    // Formats the result based on the column type
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }

                    // Updates the column footer with the formatted result
                    node.firstChild.innerHTML = resultFormat;
                },
            },
            webix.ui.datafilter.summColumn,
        );

        // Returns the configuration object for the view
        return {
            rows: [
                {
                    id: 'preloader',
                    cols: [
                        {
                            view: 'datatable', // Defines a datatable component
                            id: 'datatable',
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            select: true, // Enables row selection
                            scrollY: screen.width < 820 ? false : true, // Adjusts vertical scrolling based on screen width
                            height: screen.width < 820 ? 405 : 0, // Sets height based on screen width
                            columns: [
                                {
                                    id: 'BetShopName',
                                    header: _('Punto de Venta'), // Localized header
                                    width: 100,
                                    sort: 'int', // Enables integer sorting
                                },
                                {
                                    id: 'ActionTittle',
                                    header: '',
                                    width: 70,
                                    height: 25,
                                    hidden: !devConfig.getPermAction('withdrawalRequestsBetShop', 'Edit'), // Conditional visibility
                                    css: 'prm-withdrawalRequestsBetShop',
                                    /**
                                     * Template for rendering action buttons based on the state.
                                     * @param {Object} obj - The data object for the row.
                                     * @returns {string} The HTML string for the action buttons.
                                     */
                                    template: function(obj) {
                                        if (obj.State == 'A') {
                                            return '<span placeholder=\'Aprobar\' class=\'webix_icon wxi-close approve\'></span><span class=\'webix_icon wxi-close torefuse\'></span>';
                                        } else if (obj.State == 'P') {
                                            return '<span placeholder=\'Pagar\' class=\'webix_icon wxi-close pay\'></span>';
                                        } else {
                                            return '';
                                        }
                                    },
                                },
                                {
                                    id: 'detailTittle',
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    tooltip: _('Detalles'), // Tooltip for the column
                                    /**
                                     * Template for rendering the details button.
                                     * @param {Object} obj - The data object for the row.
                                     * @returns {string} The HTML string for the details button.
                                     */
                                    template: function(obj) {
                                        return '<span class=\'webix_icon wxi-close details\'></span>';
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: 'Id',
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'ClientId',
                                    header: _('ID Cliente'),
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Amount',
                                    header: _('Valor'),
                                    width: 100,
                                    sort: 'int',
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ',', // Thousands separator
                                        groupSize: 3,
                                        decimalDelimiter: '.', // Decimal separator
                                        decimalSize: 2, // Number of decimal places
                                    }),
                                    footer: { content: 'summColumn' }, // Adds a footer with a summary
                                    editor: 'text', // Enables text editing
                                },
                                {
                                    id: 'State',
                                    header: _('Estado'),
                                    options: [
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Pagada') },
                                        { id: 'E', value: _('Eliminado') },
                                        { id: 'P', value: _('Pendiente') },
                                        { id: 'R', value: _('Rechazado') },
                                    ], // Dropdown options for the state column
                                },
                                {
                                    id: 'CreatedLocal',
                                    header: _('Fecha Creación'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'PaymentDate',
                                    header: _('Fecha Pagado'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Description',
                                    header: _('Descripción'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'ByAllowDate',
                                    header: _('Por fecha de retiro pagado'),
                                    options: [
                                        { id: '0', value: _('No') },
                                        { id: '1', value: _('Sí') },
                                    ], // Dropdown options for the column
                                },
                            ],
                            onClick: {
                                /**
                                 * Handles the click event for the details button.
                                 * @param {Event} euv - The event object.
                                 * @param {string} id - The ID of the clicked row.
                                 */
                                details: function(euv, id) {
                                    var item = this.getItem(id);
                                    this.$scope.app.callEvent('user:id', [item.Id]);
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('windowDetailsWithdrawal').show();
                                    } else {
                                        $$('dColl').expand();
                                        $$('a5').scrollTo(0, 500);
                                    }
                                },
                                /**
                                 * Handles the click event for the pay button.
                                 * @param {Event} euv - The event object.
                                 * @param {string} id - The ID of the clicked row.
                                 */
                                pay: function(euv, id) {
                                    var vvthis = this;
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Pagar Nota de Retiro?'),
                                        ok: _('Pagar Nota'),
                                        cancel: _('Salir'),
                                        callback: function(action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id);
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/PayWithdrawalRequests',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! '));
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                item.State = 'I';
                                                                webix.message(_('Nota de Retiro Pagada'));
                                                                vvthis.$$('table').clearAll();
                                                                vvthis.$$('table').load(url);
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                /**
                                 * Handles the click event for the approve button.
                                 * @param {Event} euv - The event object.
                                 * @param {string} id - The ID of the clicked row.
                                 */
                                approve: function(euv, id) {
                                    var vvthis = this;
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Nota de Retiro?'),
                                        ok: _('Aprobar Nota'),
                                        cancel: _('Salir'),
                                        callback: function(action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id);
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/AllowWithdrawalRequests',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! '));
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                item.State = 'P';
                                                                webix.message(_('Nota de Retiro Aprobado'));
                                                                vvthis.$$('table').clearAll();
                                                                vvthis.$$('table').load(url);
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                /**
                                 * Handles the click event for the refuse button.
                                 * @param {Event} euv - The event object.
                                 * @param {string} id - The ID of the clicked row.
                                 */
                                torefuse: function(euv, id) {
                                    var vvthis = this;
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Rechazar Nota de Retiro?'),
                                        ok: _('Rechazar Nota'),
                                        cancel: _('Salir'),
                                        callback: function(action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id);
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/CancelClientRequests',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! '));
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                item.State = 'E';
                                                                webix.message(_('Nota de Retiro Rechazada'));
                                                                vvthis.$$('table').clearAll();
                                                                vvthis.$$('table').load(url);
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            editable: true, // Enables editing
                            footer: true, // Displays a footer
                            math: true, // Enables math operations
                            loadahead: 0, // Disables data preloading
                            datafetch: devConfig.getDefaultDataFetch(), // Sets the default data fetch size
                            pager: 'pagerA', // Associates a pager with the datatable
                            leftSplit: screen.width > 500 ? 1 : 0, // Splits the left columns based on screen width
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Initialize the grid component for the datatable
        grid = $$('datatable');

        // Retrieve the current user parameter from the application context
        const cur_user = this.getParam('user', true);

        // Construct the API URL for fetching client withdrawal requests
        var url = devConfig.geturlApi() + 'es/Client/GetClientWithdrawalRequests';

        // Initialize filter string for API requests
        var filter = '';

        // Set up an event listener for the 'withdrawalReport:filter' event
        this.on(this.app, 'withdrawalReport:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            var string1 = '';

            // Iterate through each filter entry
            for (var i = 0; i < object.length; i++) {
                // Check if the filter value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filtering
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Handle single date filtering
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            // Handle specific date formatting
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    // Handle object type filter values
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through nested filter entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Handle start date filtering
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle end date filtering
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Clear the grid data before loading new data
            grid.clearAll();
            // Append the current user ID to the filter string
            string1 = string1 + '&FromId=' + cur_user;
            // Load the grid with the constructed URL and filter parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Hide the filter popup after applying the filter
            $$('filterPopup').hide();
            // Store the current filter string for future use
            filter = string1;
        });

        // Attach an event listener for sorting the grid
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            // Reload the grid with the current sorting parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        // Attach an event listener for starting an edit on a grid item
        grid.attachEvent('onBeforeEditStart', function(id) {
            var item = this.getItem(id);
            console.log(item);
            // Check if the edited column is 'Action'
            if (id.column == 'Action') {
                var options = this.getColumnConfig('Action').collection;
                // Modify options based on the current state of the item
                if (item.State == 'A') {
                    options.remove('P');
                } else if (item.State == 'P') {
                    options.remove('A');
                } else {
                    return false; // Prevent editing if state is neither 'A' nor 'P'
                }
                console.log(id);
            }
        });

        // Attach an event listener for after editing a grid item
        grid.attachEvent('onAfterEditStop', function(state, editor, ignoreUpdate) {
            console.log(state);
            var item = this.getItem(editor.row);
            console.log(item);
            // Check if the edited value has changed
            if (state.value != state.old) {
                // Handle state change to 'A'
                if (state.value == 'A') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/AllowWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function(text, data, XmlHttpRequest) {
                                webix.message(_('Error! '));
                            },
                            success: function(text, data, XmlHttpRequest) {
                                item.State = 'P'; // Update item state to 'P'
                                webix.message('Cell value was changed');
                            },
                        });
                }
                // Handle state change to 'P'
                if (state.value == 'P') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/PayWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function(text, data, XmlHttpRequest) {
                                webix.message(_('Error! '));
                            },
                            success: function(text, data, XmlHttpRequest) {
                                item.State = 'I'; // Update item state to 'I'
                                webix.message('Cell value was changed');
                            },
                        });
                }
                // Handle state change to 'E'
                if (state.value == 'E') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/CancelClientRequests', '{ "Id":' + item.Id + '}', {
                            error: function(text, data, XmlHttpRequest) {
                                webix.message(_('Error! '));
                            },
                            success: function(text, data, XmlHttpRequest) {
                                item.State = 'E'; // Update item state to 'E'
                                webix.message('Cell value was changed');
                            },
                        });
                }
            }
        });

        // Set up an event listener for selecting a player
        this.on(this.app, 'player:select', (id) => {
            // Load the grid with the selected player's ID
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
